import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
  ArrowUpRight,
  Workflow,
  Activity,
  Users,
  FileText,
  Heart,
  Baby,
  Building2,
  LayoutGrid,
  BadgeEuro,
  HelpCircle,
} from "lucide-react";
import { PAGES } from "@/lib/nav";

const META = {
  "/come-funziona": { icon: Workflow, color: "#5B2C91" },
  "/esami": { icon: Activity, color: "#3B82F6" },
  "/medici": { icon: Users, color: "#0EA5E9" },
  "/referto": { icon: FileText, color: "#10B981" },
  "/anziani": { icon: Heart, color: "#E5484D" },
  "/pediatria": { icon: Baby, color: "#FF7EB3" },
  "/rsa": { icon: Building2, color: "#FF8A5B" },
  "/altri-utilizzi": { icon: LayoutGrid, color: "#8B5CF6" },
  "/prezzi": { icon: BadgeEuro, color: "#5B2C91" },
  "/faq": { icon: HelpCircle, color: "#0EA5E9" },
};

export default function ExploreSections() {
  return (
    <section id="esplora" className="bg-[#F6F4FA] py-20 sm:py-28" data-testid="explore-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 text-xs font-bold uppercase tracking-[0.18em] text-[#5B2C91]">
            <span className="h-2 w-2 rounded-full bg-[#D4F84A]" />
            Esplora
          </span>
          <motion.h2
            initial={{ opacity: 0, y: 22 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
            className="font-heading mt-5 text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-[#1F152E]"
            data-testid="explore-title"
          >
            Tutto il servizio, sezione per sezione
          </motion.h2>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {PAGES.filter((p) => META[p.path]).map((p, i) => {
            const meta = META[p.path];
            const Icon = meta.icon;
            return (
              <motion.div
                key={p.path}
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.06, ease: [0.16, 1, 0.3, 1] }}
              >
                <Link
                  to={p.path}
                  className="group flex h-full items-start gap-4 rounded-3xl bg-white p-6 ring-1 ring-[#5B2C91]/8 shadow-[0_8px_30px_rgb(91,44,145,0.05)] transition-transform duration-300 hover:-translate-y-1.5"
                  data-testid={`explore-card-${p.path.slice(1)}`}
                >
                  <span
                    className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl"
                    style={{ backgroundColor: `${meta.color}18`, color: meta.color }}
                  >
                    <Icon className="h-6 w-6" />
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center justify-between gap-2">
                      <h3 className="font-heading text-lg font-semibold text-[#1F152E]">{p.label}</h3>
                      <ArrowUpRight className="h-5 w-5 shrink-0 text-[#8A809A] transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-[#5B2C91]" />
                    </div>
                    <p className="mt-1 text-sm text-[#6B6280]">{p.desc}</p>
                  </div>
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
